
import { Component, Mixins, Prop, Ref } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Item from './views/item.vue'
import { MixinsGoCourse } from '@xt/client/mixins'
import ViewStudyCalendar from './views/studyCalendar.vue'
import CourseTab from './views/tabs.vue'
import { EnumProductTypeQuery } from '@xt/client/enums'
import EmptyComp from '@xt/www/components/system/empty.vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import { Debounce, Bind } from 'lodash-decorators'
import { reportEntryLog } from '@xt/client/utils/log'

@Observer
@Component({
  components: { Item, ViewStudyCalendar, CourseTab, EmptyComp, EmptyStatus },
  async asyncData(ctx) {
    // 读取远程JSON文件
    const res = await ctx.store.$ajax.get(
      `/mocks/studyCalendar.json`,
      {},
      { 'Cache-Control': 'no-store', 'If-Modified-Since': '0' },
      { target: ctx.store.$global.production ? 'https://static.xuantong.cn' : 'https://testing-static.xuantong.cn' }
    )

    // 6.30
    // await ctx.store.$storeUser.onGetClaimedGift()

    //单元测试用本地JSON文件
    //const res = JSONDATA
    return {
      calendar: res
    }
  }
})
export default class PageView extends Mixins(MixinsGoCourse) {
  @Prop({}) offsetTop: number
  haveNoneCourse = false
  loading = true
  calendar: any = {}
  calendarHeight = 298
  isError: boolean = false

  toClass() {
    this.$router.push({ name: 'course' })
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get userStore() {
    return this.$store.$storeUser
  }

  get EnumProductTypeQuery() {
    return EnumProductTypeQuery
  }

  calendarLoadedHandler(value: number) {
    this.calendarHeight = value
  }

  @Debounce(300, { leading: true, trailing: false })
  @Bind()
  async onloading() {
    try {
      this.loading = true

      const res = await this.$store.$my.onGetMyProductList()

      this.myProductList = res

      this.courseList = this.myProductList.progressingResultVOS

      if (this.myProductList) {
        this.haveNoneCourse = Object.keys(this.myProductList).every(key => (this.myProductList[key] ?? []).length === 0)
      }

      this.isError = false
    } catch (error) {
      reportEntryLog('toclass.loading-data.fail', { error })
      this.isError = true
    } finally {
      this.loading = false
    }
  }

  created() {
    this.onloading()
  }
  updated() {}
  destroyed() {}
}
